export class BannerApiModel {
  resourceUrl: string;

  targetUrl: string;
}
